export const learningPathsMessages = {
  warning:
    'Are you sure you want to leave this page? You have unsaved changes. If you leave the page, these changes will be lost.',
  cloning: 'The selected learning path is being cloned. Please check back in a bit.',
  exporting: 'The export is being downloaded.',
  warningUnsavedChanges:
    'Are you sure you want to leave this page? You have unsaved changes. If you leave the page, these changes will be lost!',
  errorDuplicating: 'There was an error while duplicating the learning path.',
};
